import { Color } from '@coast/schemas';
import { first, isEmpty, isNil } from 'lodash';
import { useContext } from 'react';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { Tag } from '@shared/components/blocks/lib/tags/tag';
import { MBIconV2 } from '@shared/components/image';
import { MBTypographyStyles } from '@shared/components/typography';
import { ColorThemeContext, cursorPointerStyle, grid } from '@shared/styles';
import { API } from '@shared/types/api';

interface Props {
  component: API.TagComponent | API.AuditTagComponent;
  overridePath?: string;
}

export function DefaultTagRow({ component, overridePath }: Props) {
  const colors = useContext(ColorThemeContext);
  const value = !isNil(overridePath) ? component[overridePath]?.value : component.default?.value;

  if (isEmpty(value)) {
    return null;
  }

  return (
    <MBView
      row
      centerVertically
      paddingHorizontal={2}
      paddingVertical={1}
      style={cursorPointerStyle}
    >
      <View flex row wrap shrinkWrap>
        {value.map(item => {
          const tag = first(component.options?.filter(option => option.value === item));
          return (
            <Tag
              key={tag?.value}
              color={tag?.backgroundColor as Color}
              textStyle={MBTypographyStyles.body2}
              label={tag?.label ?? ''}
            />
          );
        })}
      </View>
      <MBIconV2 name="arrow-point-right" color={colors.foregroundActive} size={grid(3)} />
    </MBView>
  );
}
